import React from 'react';
import styles from '../../styles/RagPicker.module.scss';
import { SwatchColorPicker, IColorCellProps } from '@fluentui/react/lib/SwatchColorPicker';
import { FieldErrorMessage, FieldHistory } from './FieldDecorators';
import { RagColours } from '../../refData/RagColours';
import { CrLabel } from './CrLabel';

export interface IRagPickerProps {
    label?: string;
    required?: boolean;
    className?: string;
    disabled?: boolean;
    selectedRAG?: number;
    onColorChanged?: (colorId: number) => void;
    history?: number;
    errorMessage?: string;
}

export interface IRagPickerState {
    value: number;
}

export class RagPicker extends React.Component<IRagPickerProps, IRagPickerState> {

    constructor(props: IRagPickerProps) {
        super(props);
        this.state = { value: props.selectedRAG };
    }

    private ragColors: IColorCellProps[] = [
        { id: RagColours.DarkRed.toString(), label: 'Dark Red\nCritical issues – outcome not achievable', color: '#A50126' },
        { id: RagColours.Red.toString(), label: 'Red\nSevere concerns – major risks present', color: '#DD3D2D' },
        { id: RagColours.Amber.toString(), label: 'Amber\nSome concerns – requires attention', color: '#FCD27E' },
        { id: RagColours.Green.toString(), label: 'Green\nGenerally on track – minor issues only', color: '#2DA254' },
        { id: RagColours.DarkGreen.toString(), label: 'Dark Green\nOn track – no major issues', color: '#006837' }
    ];

    public render(): React.ReactElement {
        const { className, label, required, errorMessage, disabled, selectedRAG, history } = this.props;

        return (
            <div className={className}>
                <div className={styles.ragPicker}>
                    {label &&
                        <CrLabel text={label} required={required} icon="SpeedHigh" />
                    }
                    <SwatchColorPicker
                        className={errorMessage && styles.invalid}
                        disabled={disabled}
                        columnCount={5}
                        cellShape={'circle'}
                        colorCells={this.ragColors}
                        selectedId={selectedRAG && selectedRAG.toString()}
                        onColorChanged={this._changeColor} />
                    {history &&
                        <div>
                            <FieldHistory value=' ' />
                            <SwatchColorPicker
                                disabled={true}
                                columnCount={5}
                                cellShape={'circle'}
                                colorCells={this.ragColors}
                                selectedId={history.toString()} />
                        </div>
                    }
                    {errorMessage &&
                        <FieldErrorMessage value={errorMessage} />}
                </div>
            </div>
        );
    }

    private _changeColor = (colorId: string): void => {
        this.setState({ value: parseInt(colorId) });
        if (this.props.onColorChanged) this.props.onColorChanged(parseInt(colorId));
    }
}
